// модуль для сортировки отзывов по товарам.
// при клике на пустое место закрываем всплывающее окно.

app.modules.portalReviewsSort = (function (self) {
  const SELECTORS = {
    component: '.js-portal-reviews-sort',
  };

  function _handleClick(event) {
    const reviewsTogglerEl = event.target.closest(SELECTORS.component);
    if (reviewsTogglerEl) {
      return;
    }

    const componentEl = document.querySelector(SELECTORS.component);
    componentEl && componentEl.classList.add('toggle-off');
  }

  function _listeners() {
    document.addEventListener('click', _handleClick);
  }

  self.load = _listeners;
  return self;
})(app.modules.portalReviewsSort || {});
